import React from 'react';

import Thumb from '../img/blogs/javascript-operators-functions-null-and-undefined-tips.jpg';

const JavaScriptOperatorsFunctionsNullAndUndefinedTips = {
    id: 6, permalink: "javascript-operators-functions-null-and-undefined-tips", thumb: Thumb, postBy: "Wasek Bellah", postDate: "Apr 30, 2020", categories: "JavaScript", title: "JavaScript Operators, Functions, Null and Undefined Tips", shortDesc: "Some discussion about JavaScript Equality operators, Comparisons operators, typeof operators, instanceof operator, delete Operator, Type Casting, Why not use eval, undefined, null, setTimeout and function scope.", fullDesc: <>
        <h2>Equality operators</h2>
        <p>The <strong>Equality operator</strong> is used to compare two <strong>values or expressions</strong>. It is used to compare <strong>numbers, strings, Boolean values, variables, objects, arrays, functions</strong>. The result is <strong>true</strong> if the <strong>expressions are equal</strong> and the result is <strong>false</strong> if <strong>expressions are not equal</strong>.</p>

        <p>There are have two types of <strong>equality operators</strong>. <strong>Equality <code>(==)</code> operator</strong> and <strong>Strict Equality <code>(===)</code> operator</strong>.</p>

        <p><strong>Equality <code>(==)</code> operator</strong> just check <strong>expressions value</strong>. If <strong>expressions value</strong> is <strong>true</strong> it returns <strong>true</strong>.</p>

        <pre className="code">
            console.log("" == "0"); &#47;&#47; false <br />
            console.log(0 == ""); &#47;&#47; true <br />
            console.log(0 == "0"); &#47;&#47; true <br />
            console.log(false == "false"); &#47;&#47; false <br />
            console.log(false == "0"); &#47;&#47; true <br />
            console.log(false == undefined); &#47;&#47; false <br />
            console.log(false == null); &#47;&#47; false <br />
            console.log(null == undefined); &#47;&#47; true <br />
            console.log(" \t\r\n" == 0); &#47;&#47; true
        </pre>

        <p><strong>Strict Equality <code>(===)</code> operator</strong> check <strong>expressions value and type</strong>. If one of these (value and type) or both <strong>expressions</strong> <strong>false</strong> it returns <strong>false</strong>.</p>

        <pre className="code">
            console.log("" === "0"); &#47;&#47; false <br />
            console.log(0 === ""); &#47;&#47; false <br />
            console.log(0 === "0"); &#47;&#47; false <br />
            console.log(false === "false"); &#47;&#47; false <br />
            console.log(false === "0"); &#47;&#47; false <br />
            console.log(false === undefined); &#47;&#47; false <br />
            console.log(false === null); &#47;&#47; false <br />
            console.log(null === undefined); &#47;&#47; false <br />
            console.log(" \t\r\n" === 0); &#47;&#47; false
        </pre>


        <h2>Comparisons operators</h2>
        <p>A <strong>Comparison operator</strong> is a mathematical symbol that is used to compare two values. <strong>Comparison operators</strong> are used in conditions that compare one expression with another.</p>

        <p>The <strong>Comparison operators</strong> are: <code>==</code> <strong>equal to</strong>, <code>===</code> <strong>equal value and type</strong>, <code>!=</code> <strong>not equal</strong>, <code>!==</code> <strong>not equal value and type</strong>, <code>&rsaquo;</code> <strong>greater than</strong>, <code>&lsaquo;</code> <strong>less than</strong>, <code>&rsaquo;=</code> <strong>greater than or equal to</strong>, <code>&lsaquo;=</code> <strong>less than or equal to</strong>, <code>?</code> <strong>ternary operator</strong></p>

        <pre className="code">
            if (5 >= 4) &#123; <br />
                &nbsp; console.log("5 is greater then 4"); <br />
            &#125;
        </pre>
        <p><strong>Expected output:</strong> <code className="output">5 is greater then 4</code></p>


        <h2>The typeof operators</h2>
        <p>The <code>typeof</code> operator is used to get the data type of its <strong>operand</strong>.</p>

        <p>The types in <strong>JavaScript</strong> are:</p>

        <pre class="code">
            <ul style={{ listStyleType: "inherit" }}>
                <li>String</li>
                <li>Number</li>
                <li>Object
                <ul style={{ listStyleType: "square" }}>
                        <li>Array</li>
                        <li>Null</li>
                        <li>Date</li>
                        <li>RegExp</li>
                    </ul>
                </li>
                <li>Function</li>
                <li>Boolean</li>
                <li>Symbol <small>(new in ES2015)</small></li>
                <li>BigInt <small>(new in ES2020)</small></li>
                <li>Undefined</li>
            </ul>
        </pre>

        <p>Check some <strong>data types</strong> using <code>typeof()</code>:</p>

        <pre className="code">
            console.log(typeof ("Wasek Bellah")) &#47;&#47; String <br />
            console.log(typeof (123)) &#47;&#47; Number <br />
            console.log(typeof (&#123; name: "Wasek Bellah", age: 21 &#125;)) &#47;&#47; Object <br />
            console.log(typeof (["Wasek Bellah", 21])) &#47;&#47; Array <br />
            console.log(typeof (null))  &#47;&#47; null <br />
            console.log(typeof (new Date())) &#47;&#47; Date <br />
            console.log(typeof (/regex/)) &#47;&#47; RegExp <br />
            console.log(typeof (fun = (a, b) => a + b)) &#47;&#47; Function <br />
            console.log(typeof (true)) &#47;&#47; Boolean <br />
            console.log(typeof (Symbol("Sym"))) &#47;&#47; Symbol <br />
            console.log(typeof (2n)) &#47;&#47; BigInt <br />
            console.log(typeof (undefined)) &#47;&#47; undefined
        </pre>
        <p><strong>Expected output:</strong> <code className="output">string, number, object, object, object, object, object, function, boolean, symbol, bigint, undefined</code></p>


        <h2>The instanceof operator</h2>
        <p>The <code>instanceof</code> operator is used to check the type of an <strong>object</strong> during a run.</p>

        <p>The <code>instanceof</code> operator returns <code>true</code> if the specified <strong>object</strong> is an instance of the specified <strong>object</strong></p>

        <pre className="code">
            var ages = [21, 23, 19, 20]; <br />
            console.log((ages instanceof Array)); <br />
            console.log((ages instanceof Object)); <br />
            console.log((ages instanceof String)); <br />
            console.log((ages instanceof Number));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true, true, false, false</code></p>


        <h2>Type Casting</h2>
        <p><strong>Type Casting</strong> means changing the <strong>data type</strong> of a value to another <strong>data type</strong> as <strong>integer to a string</strong> or a <strong>string to a boolean</strong>, etc.</p>

        <p>There are two types of <strong>typecasting, implicit and explicit</strong>. <strong>Implicit typecasting</strong> is the automatic conversion of <strong>data type</strong>, and <strong>Explicit typecasting</strong> is when expresses the intention to convert between <strong>types</strong> by writing the appropriate code.</p>

        <pre className="code">
            console.log(new Number(10) == 10); <br />
            console.log(10 == '10'); <br />
            console.log(10 == '+10 '); <br />
            console.log(10 == '010'); <br />
            console.log(isNaN(null) == false); <br />
            console.log(10 == 010); <br />
            console.log(10 == '-10');
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true, true, true, true, true, false, false</code></p>


        <h2>Why not use eval</h2>
        <p>The <code>eval()</code> <strong>function</strong> evaluates or executes an argument.</p>

        <p>If the argument is an expression, <code>eval()</code> evaluates the expression. If the argument is one or more <strong>JavaScript statements</strong>, <code>eval()</code> executes the statements.</p>

        <pre className="code">
            console.log("4 + 4"); <br />
            console.log(eval("4 + 4"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">4 + 4</code> and <code className="output">8</code></p>

        <p><code>eval()</code> is a dangerous <strong>function</strong>, which executes the code it's passed with the privileges of the <strong>caller</strong>.</p>

        <p>It is not recommended to use <code>eval()</code> because it is <strong>slow, not secure, and makes code unreadable and maintainable</strong>.</p>


        <h2>undefined and null</h2>
        <h3>undefined</h3>
        <p><code>undefined</code> means a <strong>variable</strong> has been declared, but the value of that <strong>variable</strong> has not yet been defined.</p>

        <pre className="code">
            var name; <br />
            console.log(name);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">undefined</code></p>

        <p><code>undefined</code> is of the type <strong>undefined</strong></p>

        <pre className="code">
            var name; <br />
            console.log(typeof (name));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">undefined</code></p>

        <h3>null</h3>
        <p><code>null</code> means an <strong>empty value</strong>. <code>null</code> has been allocated and clearly implies nothing.</p>

        <pre className="code">
            console.log(null);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">null</code></p>

        <p><code>null</code> is an <strong>object</strong></p>

        <pre className="code">
            console.log(typeof (null));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">object</code></p>

        <h3>null vs undefined</h3>
        <p><code>null</code> and <code>undefined</code> are the same in <strong>value</strong>, but different in <strong>data types</strong>.</p>

        <pre className="code">
            console.log(null == undefined); <br />
            console.log(null === undefined);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>


        <h2>The delete Operator</h2>
        <p>The <code>delete</code> operator is employed to delete a property of an <strong>object</strong>. After <strong>deleting</strong> the property of the <strong>object</strong>, that property will not be accessible. And it will return <code>undefined</code>.</p>

        <pre className="code">
            var person = &#123; name: "Wasek Bellah", age: 21 &#125; <br />
            console.log(person.age);
            </pre>
        <p><strong>Expected output:</strong> <code className="output">21</code></p>

        <pre className="code">
            var person = &#123; name: "Wasek Bellah", age: 21 &#125; <br />
            delete person.age; <br />
            console.log(person.age);
            </pre>
        <p><strong>Expected output:</strong> <code className="output">undefined</code></p>


        <h2>setTimeout</h2>
        <p>The <code>setTimeout()</code> method calls a <strong>function</strong> or <strong>an expression evaluation</strong> after a specified number of <strong>milliseconds (1000ms = 1s)</strong>.</p>

        <pre className="code">
            setTimeout(function()&#123; alert("Hello, Wasek Bellah"); &#125;, 3000);
        </pre>
        <p>The <strong>alert</strong> will open after 3 second.</p>
        <p><strong>Expected output:</strong> <code className="output">Hello, Wasek Bellah</code></p>


        <h2>Function scope</h2>
        <p><strong>Scope</strong> determines the accessibility of the <strong>variable</strong>.</p>

        <p><em>In <strong>JavaScript</strong> there are two types of scope</em>:</p>
        <ul>
            <li>Global scope</li>
            <li>Local scope</li>
        </ul>

        <p><strong>JavaScript</strong> has <strong>function scope</strong>: Each <strong>function</strong> creates a new <strong>scope</strong>.</p>

        <pre className="code">
            var name = "Wasek Bellah"; <br />
            function nameAge() &#123; <br />
                &nbsp; var age = 21; <br />
                &nbsp; console.log("Name: " + name + " and Age: " + age); <br />
            &#125; <br />
            nameAge(); <br />
            console.log(name);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Name: Wasek Bellah and Age: 21</code>, and <code className="output">Wasek Bellah</code></p>

        <pre className="code">
            var name = "Wasek Bellah"; <br />
            function nameAge() &#123; <br />
                &nbsp; var age = 21; <br />
            &#125; <br />
            nameAge(); <br />
            console.log("Name: " + name + " and Age: " + age);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">ReferenceError: age is not defined</code></p>

        <p>Above 2 examples, the <code>name</code> <strong>variable</strong> can be accessed from anywhere. But <code>age</code> can not be accessed outside of the <strong>function</strong>.</p>

        <p>That's why we can say, the <code>name</code> is the <strong>Global scope</strong>, and <code>age</code> is the <strong>Local scope</strong>.</p>

        <p>If you want to access a <strong>variable</strong> from a <strong>function</strong> then you have to declare that <strong>variable</strong> first and assign a value into the <strong>function</strong>. After that, you can get that value from outside of the <strong>function</strong>.</p>

        <pre className="code">
            var age; <br />
            function nameAge() &#123; <br />
                &nbsp; age = 21; <br />
            &#125; <br />
            nameAge(); <br />
            console.log("Age: " + age);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Age: 21</code></p>
    </>
};
export default JavaScriptOperatorsFunctionsNullAndUndefinedTips;